export default __webpack_public_path__ + "static/media/pack2.40afa563.png";